<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewTask"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchTasks"
            @resetFilters="resetFilters"
            @importData="importLeads"
            @removeItem="removeTask"
            @removeSelectedItems="removeTasks"
            @printList="printCustomersList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="tasksList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveTask" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="transModalVisible" :title="title1" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative">
                    <label for="">System SMS Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="templateArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedTemplate"
                        @clearSearch="clearSelectedTemplate"                               
                    />
                </div>
                <div class="text-left mb-4">
                    <label for="">Message:</label><br />
                    <!-- <quill-editor :key="editorComponentKey" v-model:value="messageContent"></quill-editor> -->

                    <div class="flex">
                        <div class="basis-1/2 mb-4 mr-3">
                            <select v-model="selectedPlaceholder" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-1 w-full">
                                <option value="" disabled>Select Placeholder</option>
                                <option v-for="placeholder in leadPlaceholders" :key="placeholder.value" :value="placeholder.value">
                                    {{ placeholder.label }}
                                </option>
                            </select>
                        </div>
                        <button @click="insertPlaceholder" :disabled="!selectedPlaceholder" class="w-24 h-8 rounded bg-green-400 text-sm mr-2  text-white px-2 py-0.5">Insert</button>
                    </div>

                    <textarea v-model="contentModel" ref="textareaRef" rows="8" cols="64" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-2" placeholder="Type your content here..."></textarea>
                </div>
                <button @click="sendClientSMS" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send SMS</button>
            </div>
        </MovableModal>
        <MovableModal v-model:visible="emailModalVisible" :title="title2" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative mb-4">
                    <label for="">System Email Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="emailTempArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedEmailTemplate"
                        @clearSearch="clearSelectedEmailTemplate"                               
                    />
                </div>
                <button @click="sendClientEmail" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send Email</button>
            </div>
        </MovableModal>
        <MovableModal v-model:visible="oppModalVisible" :title="title3" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader3" @showLoader="showModalLoader3" @hideLoader="hideModalLoader3" @closeModal="closeModal3">
            <DynamicForm 
                :fields="formFields3" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="qualifyLead" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import SearchableDropdown from "@/components/SearchableDropdown.vue";
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { quillEditor } from 'vue3-quill';
import { useTextareaEditor } from '@/composables/TextAreaEditor';
import Swal from 'sweetalert2';

export default{
    name: 'Lead_Tasks',
    components:{
        PageComponent, MovableModal,DynamicForm,quillEditor,SearchableDropdown
    },
    setup(){
        const { contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,} = useTextareaEditor('');
        const templateArr = computed(() => store.state.Crm_SMS_Templates.templateArr);
        const emailTempArr = computed(() => store.state.Crm_Email_Templates.templateArr);
        const emailTempID = ref('');
        const dropdownWidth = ref("500px");
        const messageContent = ref('');
        const modal_loader1 = ref('none');
        const modal_loader3 = ref('none');
        const title1 = ref('SMS Lead(s)');
        const title2 = ref('Email Lead(s)');
        const title3 = ref('Qualify Lead');
        const transModalVisible = ref(false);
        const emailModalVisible = ref(false);
        const oppModalVisible = ref(false);
        const currComponentKey = ref(0);
        const agentComponentKey = ref(0);
        const chanComponentKey = ref(0);
        const taskID = ref('');
        const opportunityID = ref(null);
        const agentID = ref(null);
        const leadID = ref(null);
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const idField = 'crm_task_id';
        const addButtonLabel = ref('New Task');
        const title = ref('Task Details');
        const addingRight = ref('Adding CRM Tasks');
        const removingRight = ref('Deleting CRM Tasks');
        const rightsModule = ref('CRM');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const tasksList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Lead_Tasks.isEditing);
        const selectedTask = computed(()=> store.state.Lead_Tasks.selectedTask);
        const selectedOpportunity = computed(()=> store.state.Lead_Tasks.selectedOpportunity);
        const selectedRep = computed(()=> store.state.Lead_Tasks.selectedRep);
        const selectedLead = computed(()=> store.state.Lead_Tasks.selectedLead);
        const opportunityArray = computed(() => store.state.Opportunities.opportunityArr);
        const agentArray = computed(() => store.state.Sales_Reps.agentArr);
        const leadArray = computed(() => store.state.Sales_Leads.leadArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Title", key:"title"},
            {label: "Sales Rep", key:"assigned_to"},
            {label: "Type", key: "task_type"},
            {label: "Due Date", key:"due_date"},
            {label: "Time", key: "task_time"},
            {label: "Lead", key:"related_lead"},
            {label: "Opportunity", key:"related_opportunity"},
            {label: "Reminder", key:"enable_reminders"},
            {label: "Mode", key:"reminder_mode"},
            {label: "Status", key:"status", textColor:"statusColor"},
            {label: " ", key:"statusIcon"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Task', rightName: 'Editing CRM Tasks'},
            // {name: 'send-sms', icon: 'fas fa-comment', title: 'Send SMS', rightName: 'Sending CRM SMS'},
            // {name: 'send-email', icon: 'fas fa-envelope', title: 'Send Email', rightName: 'Sending CRM Emails'},
            // {name: 'convert', icon: 'fa fa-sign-in', title: 'Update Task', rightName: 'Editing CRM Tasks'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Task', rightName: 'Deleting CRM Tasks'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const to_date_search = ref("");
        const title_search = ref("");
        const from_date_search = ref("");
        const task_type_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: title_search, width:48,},
            {type:'date', placeholder:"From Date...", value: from_date_search, width:32, title: "Date From Search"},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:32, title: "Date To Search"},
            {
                type:'dropdown', placeholder:"Type..", value: task_type_search, width:28,
                options: [{text:'Follow Up',value:'Follow Up'},{text:'Reminder',value:'Reminder'}]
            },

        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchLeadOpportunitys = async() =>{
            await store.dispatch('Opportunities/fetchLeadOpportunitys', {company:companyID.value})
        };
        const handleSelectedOpportunity = async(option) =>{
            await store.dispatch('Opportunities/handleSelectedOpportunity', option)
            opportunityID.value = store.state.Opportunities.opportunityID;
            if(selectedTask.value && selectedOpportunity.value){
                selectedTask.value.related_opportunity.opportunity_id = opportunityID.value;
            }
        }
        const clearSelectedOpportunity = async() =>{
            await store.dispatch('Opportunities/updateState', {opportunityID: ''});
            opportunityID.value = store.state.Opportunities.opportunityID;
            if(selectedTask.value && selectedOpportunity.value){
                selectedTask.value.related_opportunity.opportunity_id = opportunityID.value;
            }
        }
        const fetchMarketingLeads = async() =>{
            await store.dispatch('Sales_Leads/fetchMarketingLeads', {company:companyID.value})
        };
        const handleSelectedLead = async(option) =>{
            await store.dispatch('Sales_Leads/handleSelectedLead', option)
            leadID.value = store.state.Sales_Leads.leadID;
            if(selectedTask.value && selectedLead.value){
                selectedTask.value.related_lead.lead_id = leadID.value;
            }
        }
        const clearSelectedLead = async() =>{
            await store.dispatch('Sales_Leads/updateState', {leadID: ''});
            leadID.value = store.state.Sales_Leads.leadID;
            if(selectedTask.value && selectedLead.value){
                selectedTask.value.related_lead.lead_id = leadID.value;
            }
        }
        const fetchSalesAgents = async() =>{
            await store.dispatch('Sales_Reps/fetchSalesAgents', {company:companyID.value})
        };
        const handleSelectedAgent = async(option) =>{
            await store.dispatch('Sales_Reps/handleSelectedAgent', option)
            agentID.value = store.state.Sales_Reps.agentID;
            if(selectedTask.value && selectedRep.value){
                selectedTask.value.assigned_to.sales_rep_id = agentID.value;
            }
        }
        const clearSelectedAgent = async() =>{
            await store.dispatch('Sales_Reps/updateState', {agentID: ''});
            agentID.value = store.state.Sales_Reps.agentID;
        }
        const agentValue = computed(() => {
           return (selectedTask.value && selectedTask.value.assigned_to && !agentID.value) ? selectedTask.value.assigned_to.sales_rep_id : agentID.value;
        });
        const oppValue = computed(() => {
           return (selectedTask.value && selectedTask.value.related_opportunity && !opportunityID.value) ? selectedTask.value.related_opportunity.opportunity_id : opportunityID.value;
        });
        const leadValue = computed(() => {
           return (selectedTask.value && selectedTask.value.related_lead && !leadID.value) ? selectedTask.value.related_lead.lead_id : leadID.value;
        });
        const displayReminderFields = (value) =>{
            if(value == 'Reminder'){
                
                formFields.value[9].hidden = false;
                formFields.value[10].hidden = false;
                formFields.value[11].hidden = false;
                formFields.value[12].hidden = false;
            }else{
                formFields.value[9].hidden = true;
                formFields.value[10].hidden = true; 
                formFields.value[11].hidden = true;
                formFields.value[12].hidden = true;
            }
        }
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Sales Rep", value: agentValue.value, componentKey: agentComponentKey,
                    selectOptions: agentArray, optionSelected: handleSelectedAgent, required: false,
                    searchPlaceholder: 'Select Rep...', dropdownWidth: '350px', updateValue: selectedRep.value,
                    clearSearch: clearSelectedAgent
                },
                {  
                    type:'search-dropdown', label:"Lead", value: leadValue.value, componentKey: chanComponentKey,
                    selectOptions: leadArray, optionSelected: handleSelectedLead, required: false,
                    searchPlaceholder: 'Select Lead...', dropdownWidth: '350px', updateValue: selectedLead.value,
                    clearSearch: clearSelectedLead
                },
                {  
                    type:'search-dropdown', label:"Opportunity", value: oppValue.value, componentKey: currComponentKey,
                    selectOptions: opportunityArray, optionSelected: handleSelectedOpportunity, required: false,
                    searchPlaceholder: 'Select Opportunity...', dropdownWidth: '350px', updateValue: selectedOpportunity.value,
                    clearSearch: clearSelectedOpportunity
                },
                
                { type: 'text', name: 'title',label: "Title", value: selectedTask.value?.title || '', required: true },
                { type: 'date', name: 'due_date',label: "Due Date", value: selectedTask.value?.due_date || '', required: true },
                { type: 'time', name: 'task_time',label: "Task Time", value: selectedTask.value?.task_time || '', required: true },
                { type: 'dropdown', name: 'task_type',label: "Task Type", value: selectedTask.value?.task_type || 'Follow Up', required: true , options: [{text:'Follow Up',value:'Follow Up'},{text:'Reminder',value:'Reminder'}], method: displayReminderFields },
                { type: 'text-area', name: 'notes',label: "Notes", value: selectedTask.value?.notes || '', textarea_rows: '3', textarea_cols: '56', required: false },
                { type: 'dropdown', name: 'status',label: "Status", value: selectedTask.value?.status || 'Not Started', required: true , options: [{text:'Complete',value:'Complete'},{text:'Not Started',value:'Not Started'},{text:'In Progress',value:'In Progress'}] },
                { type: 'dropdown', name: 'reminder_type',label: "Reminder Channel", value: selectedTask.value?.reminder_type || 'None', required: true, hidden: true , options: [{text:'SMS',value:'SMS'},{text:'Email',value:'Email'},{text:'Both',value:'Both'},{text:'None',value:'None'}] },
                { type: 'dropdown', name: 'enable_reminders',label: "Enable Reminder", value: selectedTask.value?.enable_reminders || 'No', placeholder: "", required: true, hidden: true, options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }] },
                { type: 'dropdown', name: 'reminder_mode',label: "Reminder Mode", value: selectedTask.value?.reminder_mode || 'On Schedule Day', placeholder: "", required: true, hidden: true, options: [{ text: 'On Schedule Day', value: 'On Schedule Day' }, { text: 'Day(s) Before and After Schedule Date', value: 'Before and After Schedule Date' },{ text: 'Day(s) Before Schedule Date', value: 'Before Schedule Date' }, { text: 'Day(s) After Schedule Date', value: 'After Schedule Date' },{ text: 'On Schedule Day and Day(s) Before Schedule Date', value: 'On Schedule Day and Before Schedule Date' }, { text: 'On Schedule Day and Day(s) After Schedule Date', value: 'On Schedule Day and After Schedule Date' }] },
                { type: 'number', name: 'reminder_days',label: "Reminder Days", value: selectedTask.value?.reminder_days || 1, required: false, hidden: true },
                {required: false}
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            formFields.value[6].value = 'Follow Up';
            formFields.value[8].value = 'Not Started';
            formFields.value[9].value = 'None';
            formFields.value[10].value = 'No';
            formFields.value[11].value = 'On Schedule Day';
            formFields.value[12].value = 1;
            agentComponentKey.value += 1;
            chanComponentKey.value += 1;
            currComponentKey.value += 1;

        }

        watch([selectedTask, selectedOpportunity, selectedRep, selectedLead], () => {
            if (selectedTask.value && selectedOpportunity.value && selectedRep.value && selectedLead.value) {
                updateFormFields();
                currComponentKey.value += 1;
                agentComponentKey.value += 1;
                chanComponentKey.value += 1;
                if(selectedTask.value.task_type == 'Reminder'){
                    formFields.value[9].hidden = false;
                    formFields.value[10].hidden = false;
                    formFields.value[11].hidden = false;
                    formFields.value[12].hidden = false;
                }
            }
            else if(selectedTask.value && selectedOpportunity.value && selectedRep.value ) {
                updateFormFields();
                currComponentKey.value += 1;
                agentComponentKey.value += 1;
                if(selectedTask.value.task_type == 'Reminder'){
                    formFields.value[9].hidden = false;
                    formFields.value[10].hidden = false;
                    formFields.value[11].hidden = false;
                    formFields.value[12].hidden = false;
                }
            }
            else if (selectedTask.value && selectedOpportunity.value && selectedLead.value) {
                updateFormFields();
                currComponentKey.value += 1;
                chanComponentKey.value += 1;
                if(selectedTask.value.task_type == 'Reminder'){
                    formFields.value[9].hidden = false;
                    formFields.value[10].hidden = false;
                    formFields.value[11].hidden = false;
                    formFields.value[12].hidden = false;
                }
            }
            else if(selectedTask.value && selectedRep.value && selectedLead.value) {
                updateFormFields();
                agentComponentKey.value += 1;
                chanComponentKey.value += 1;
                if(selectedTask.value.task_type == 'Reminder'){
                    formFields.value[9].hidden = false;
                    formFields.value[10].hidden = false;
                    formFields.value[11].hidden = false;
                    formFields.value[12].hidden = false;
                }
            }
            else if(selectedOpportunity.value){
                updateFormFields();
                currComponentKey.value += 1;
            }
            else if(selectedRep.value){
                updateFormFields();
                agentComponentKey.value += 1;
            }
            else if(selectedLead.value){
                updateFormFields();
                chanComponentKey.value += 1;
            }
            else if (selectedTask.value) {
                updateFormFields();
                if(selectedTask.value.task_type == 'Reminder'){
                    formFields.value[9].hidden = false;
                    formFields.value[10].hidden = false;
                    formFields.value[11].hidden = false;
                    formFields.value[12].hidden = false;
                }     
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createLeadTask = async() =>{
            showModalLoader();
            let formData = {
                title: formFields.value[3].value,
                due_date: formFields.value[4].value,
                task_time: formFields.value[5].value || null,
                task_type: formFields.value[6].value,
                notes: formFields.value[7].value,
                status: formFields.value[8].value,
                enable_reminders: formFields.value[10].value,
                reminder_type: formFields.value[9].value,
                reminder_mode: formFields.value[11].value,
                reminder_days: formFields.value[12].value,
                reminder_sent: 'No',
                related_opportunity: opportunityID.value,
                related_opportunity_id: opportunityID.value,
                related_lead: leadID.value,
                related_lead_id: leadID.value,
                assigned_to: agentID.value,
                assigned_to_id: agentID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push(formFields.value[i].label);
                }
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Lead_Tasks/createLeadTask', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Task created successfully!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Task.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Task: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchTasks();
                }
            }
        }
        const updateLeadTask = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                crm_task: selectedTask.value.crm_task_id,
                title: formFields.value[3].value,
                due_date: formFields.value[4].value,
                task_time: formFields.value[5].value || null,
                task_type: formFields.value[6].value,
                notes: formFields.value[7].value,
                status: formFields.value[8].value,
                enable_reminders: formFields.value[10].value,
                reminder_type: formFields.value[9].value,
                reminder_mode: formFields.value[11].value,
                reminder_days: formFields.value[12].value,
                reminder_sent: selectedTask.value.reminder_sent,
                related_opportunity: oppValue.value,
                related_opportunity_id: oppValue.value,
                related_lead: leadValue.value,
                related_lead_id: leadValue.value,
                assigned_to: agentValue.value,
                assigned_to_id: agentValue.value,
                company: companyID.value
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Lead_Tasks/updateLeadTask', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        toast.success("Task updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Task.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Task: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    await store.dispatch("Lead_Tasks/updateState",{selectedTask:null,selectedOpportunity:null,selectedRep:null,selectedLead:null, isEditing:false})
                    searchTasks();
                }             
            }
        }
        const saveTask = () =>{
            if(isEditing.value == true){
                updateLeadTask();
            }else{
                createLeadTask();
            }
        }
        const importLeads = () =>{
            
        }
        const removeTask = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    crm_task: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Lead_Tasks/deleteLeadTask',formData)
                    if(response && response.status == 200){
                        toast.success("Task Removed Succesfully");
                        searchTasks();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Task: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Task") 
            }else{
                toast.error("Please Select A Task To Remove")
            }
        }
        const removeTasks = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    crm_task: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Lead_Tasks/deleteLeadTask',formData)
                    if(response && response.status == 200){
                        toast.success("Task(s) Removed Succesfully");
                        searchTasks();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Task: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select A Task To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchTasks = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                title: title_search.value,
                to_date: to_date_search.value,
                from_date: from_date_search.value,
                task_type: task_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/lead-tasks-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                tasksList.value = response.data.results;
                store.commit('Lead_Tasks/LIST_LEAD_TASKS', tasksList.value)
                propResults.value = response.data;
                propArrLen.value = tasksList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchTasks(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            to_date_search.value = "";
            title_search.value = "";
            from_date_search.value = "";
            task_type_search.value = "";
            searchTasks();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchTasks();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchTasks();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchTasks();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchTasks();
            // scrollToTop();
        }
        const formFields3 = ref([]);
        const updateFormFields3 = () => {
            formFields3.value = [
                { type: 'date', name: 'expected_close_date',label: "Expected Close Date", value: null, required: false },
                { type: 'number', name: 'value',label: "Estimated Value", value: 0, required: false },
                { type: 'number', name: 'probability',label: "Probability", value: 0, required: false },
                { type: 'text-area', name: 'notes',label: "Notes", value: '', textarea_rows: '3', textarea_cols: '56', required: false },
            ];
        };
        const handleReset3 = () =>{
            for(let i=0; i < formFields3.value.length; i++){
                formFields3.value[i].value = null;
            }
            formFields3.value[1].value = 0;
            formFields3.value[2].value = 0;
        }
        const showModalLoader3 = () =>{
            modal_loader3.value = "block";
        }
        const hideModalLoader3 = () =>{
            modal_loader3.value = "none";
        }
        const closeModal3 = () =>{
            propModalVisible.value = false;
            taskID.value = "";
            handleReset3();
        };
        const qualifyLead = async() =>{
            showModalLoader3();
            let formData = {
                lead: taskID.value,
                expected_close_date: formFields3.value[0].value || null,
                value: formFields3.value[1].value,
                probability: formFields3.value[2].value,
                notes: formFields3.value[3].value,
                company: companyID.value,
                user: userID.value
            }
  
            try {
                const response = await axios.post('api/v1/qualifying-marketing-lead/', formData);
                if (response && response.data.msg === "Success") {
                    hideModalLoader3();
                    toast.success('Lead qualified successfully!');
                    handleReset3();
                    propModalVisible.value = false;
                    searchTasks();
                } else {
                    toast.error('An error occurred while qualifying the Lead.');
                }
            } catch (error) {
                console.error(error.message);
                toast.error('Failed to qualify Lead: ' + error.message);
            } finally {
                hideModalLoader3();
            }
        }
        const addNewTask = async() =>{
            updateFormFields();
            await store.dispatch("Lead_Tasks/updateState",{selectedTask:null,selectedOpportunity:null,selectedLead:null, selectedRep: null, isEditing:false})
            propModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.33';
            modal_width.value = '60vw';
            chanComponentKey.value += 1;
            agentComponentKey.value += 1;
            currComponentKey.value += 1;
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const taskID = row[idField];
                let formData = {
                    company: companyID.value,
                    crm_task: taskID
                }
                await store.dispatch('Lead_Tasks/fetchLeadTask',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.33';
                modal_width.value = '60vw';

            }else if(action == 'send-sms'){
                fetchTemplates();
                taskID.value = [row[idField]];
                transModalVisible.value = true;
                
            }else if(action == 'send-email'){
                fetchEmailTemplates();
                taskID.value = [row[idField]];
                emailModalVisible.value = true;
            }else if(action == "convert"){
                taskID.value = row[idField];   
                const leadStatus = row['status'];
                if(leadStatus == 'Converted' || leadStatus == 'Qualified'){
                    Swal.fire(`Lead Already ${leadStatus}!`, {
                        icon: "warning",
                    });
                    return;
                }
                if(leadStatus == 'Lost'){
                    Swal.fire("Cannot Qualify A Lost Lead!", {
                        icon: "warning",
                    });
                    return;
                }
                oppModalVisible.value = true;
                updateFormFields3();
                flex_basis.value = '1/2';
                flex_basis_percentage.value = '50';
                modal_width.value = '30vw';
            }else if(action == 'delete'){
                const taskID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    crm_task: taskID
                }
                await store.dispatch('Lead_Tasks/deleteLeadTask',formData).
                then(()=>{
                    searchTasks();
                })
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCustomersList = () =>{
            

        };
        const showModalLoader1 = () =>{
            modal_loader1.value = "block";
        }
        const hideModalLoader1 = () =>{
            modal_loader1.value = "none";
        }
        const handleReset1 = () =>{
            contentModel.value = "";
            taskID.value = "";
        };
        const fetchTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_SMS_Templates/fetchTemplates", formData)
        };
        const fetchEmailTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_Email_Templates/fetchTemplates", formData)
        };
        const handleSelectedTemplate = async(option) =>{
            await store.dispatch('Crm_SMS_Templates/handleSelectedTemplate', option)
            contentModel.value = store.state.Crm_SMS_Templates.templateContent;
        };
        const clearSelectedTemplate = async() =>{
            await store.dispatch('Crm_SMS_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
        }
        const sendClientSMS = async() =>{
            if(taskID.value && contentModel.value){
                showModalLoader1();
                let formData = {
                    content: contentModel.value,
                    client: taskID.value,
                    company: companyID.value
                }
                await axios.post('api/v1/leads-general-sms/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("SMS Sent!")
                        closeModal1();
                        searchTasks();
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideModalLoader1();
                })
            }else if(taskID.value == ""){
                toast.error("No Lead Selected!!")
            }else if(contentModel.value == ""){
                toast.error("Cannot Send Blank SMS!!")
            }
            
        };
        const handleSelectedEmailTemplate = async(option) =>{
            await store.dispatch('Crm_Email_Templates/handleSelectedTemplate', option)
            emailTempID.value = store.state.Crm_Email_Templates.templateID;
        };
        const clearSelectedEmailTemplate = async() =>{
            await store.dispatch('Crm_Email_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
            emailTempID.value = '';
        }
        const sendClientEmail = async() =>{
            showModalLoader1();
            let formData = {
                template: emailTempID.value,
                lead: taskID.value,
                company: companyID.value
            }
            await axios.post('api/v1/leads-general-email/',formData).
            then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Email Sent!")
                    closeModal1();
                    searchTasks();
                }else{
                    toast.error(response.data.msg)
                }
            })
            .catch((error)=>{
                toast.error(error.message)
            })
            .finally(()=>{
                hideModalLoader1();
            })
            
        };
        const dropdownOptions = ref([
            // {label: 'SMS Selected Lead', action: 'send-sms', icon: 'fa-sms', colorClass: 'text-blue-600', rightName: 'Sending CRM SMS'},
            // {label: 'Email Selected Lead', action: 'send-email', icon: 'fa-envelope', colorClass: 'text-indigo-600', rightName: 'Sending CRM Emails'},
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'send-sms'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select A Lead To Send SMS")
                    return;
                }
                fetchTemplates();
                taskID.value = selectedIds.value;
                transModalVisible.value = true;
                
            }else if(option == 'send-email'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select A Lead To Send Email")
                    return;
                }
                fetchEmailTemplates();
                taskID.value = selectedIds.value;
                emailModalVisible.value = true;
            }
        };
        const closeModal1 = async() =>{
            transModalVisible.value = false;
            emailModalVisible.value = false;
            handleReset1();
        }
        onBeforeMount(()=>{
            searchTasks();
            fetchLeadOpportunitys();
            fetchSalesAgents();
            fetchMarketingLeads();
        })
        return{
            title, searchTasks,resetFilters, addButtonLabel, searchFilters, tableColumns, tasksList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,dropdownOptions,handleDynamicOption,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewTask, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveTask, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            importLeads, removeTask, removeTasks, handleReset,printCustomersList,addingRight,removingRight,rightsModule,selectSearchQuantity,selectedValue,
            messageContent,modal_loader1,title1,showModalLoader1,hideModalLoader1,sendClientSMS,transModalVisible,emailModalVisible,title2,
            closeModal1,contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,templateArr,dropdownWidth,
            handleSelectedTemplate,clearSelectedTemplate,handleSelectedEmailTemplate,clearSelectedEmailTemplate,emailTempArr,sendClientEmail,
            formFields3, handleReset3, showModalLoader3, hideModalLoader3, qualifyLead,oppModalVisible, title3,modal_loader3,closeModal3
        }
    }
};
</script>